import { Sport } from "../../sport-slice";
import { PlayPayloadBase, PlayPayloadProperties } from "./play-payload-generic";

export enum SoccerDrawingArea {
  FULL = 1,
  LEFT_HALF = 2,
  RIGHT_HALF = 3,
  LEFT_QUARTER = 4,
  RIGHT_QUARTER = 5,
}

export interface SoccerPlayPayloadProperties {
  outOfBounds?: boolean | "true" | "false";
}

export interface PlayPayloadSoccer extends PlayPayloadBase {
  sport: Sport.SOCCER;
  drawingArea?: SoccerDrawingArea;
  properties?: Partial<PlayPayloadProperties> & SoccerPlayPayloadProperties;
}
